"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var braft_utils_1 = require("braft-utils");
var Variables_1 = __importDefault(require("../Components/Variables"));
var ControlBarButton_1 = __importDefault(require("../Components/ControlBarButton"));
var RightContent = function (_a) {
    var editorState = _a.editorState, setEditorState = _a.setEditorState, variables = _a.variables, expanded = _a.expanded, setExpanded = _a.setExpanded;
    return (react_1.default.createElement(antd_1.Row, { gutter: 4, align: "middle" },
        variables && (react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(Variables_1.default, { onVariableClick: function (option) {
                    setEditorState(braft_utils_1.ContentUtils.insertText(editorState, option.key, editorState.getCurrentInlineStyle()));
                }, variables: variables }))),
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(ControlBarButton_1.default, { onClick: function () { return setExpanded === null || setExpanded === void 0 ? void 0 : setExpanded(function (prev) { return !prev; }); }, icon: !expanded ? react_1.default.createElement(icons_1.FullscreenOutlined, null) : react_1.default.createElement(icons_1.FullscreenExitOutlined, null) }))));
};
exports.default = RightContent;
